<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="收票编号">
              <a-input placeholder="请输入收票编号" v-model="searchModel.invoiceNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="合同名称">
              <a-input placeholder="请输入合同名称" v-model="searchModel.contractName" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商名称">
              <a-select
                :allowClear="true"
                v-model="searchModel.companyId"
                showSearch
                optionFilterProp="children"
                placeholder="请选择供应商名称"
              >
                <a-select-option v-for="(item, index) in supplierList" :value="item.id" :key="index">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>
import { getSuppliers } from '@/api/business/invoice'

export default {
  name: 'MarketsSearchForm',
  mounted () {
    // 获取供应商列表
    this.getSuppliersList()
  },
  computed: {
    projectList () {
      return this.$store.state.contract.projectList
    }
  },
  data () {
    return {
      showExpend: false,

      searchModel: {},
      advanced: false, // 是否展开

      // 供应商列表
      supplierList: []
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.invoiceNo) {
        model.invoiceNo = model.invoiceNo.trim()
      }
      if (model.contractName) {
        model.contractName = model.contractName.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    },
    // 获取select列表
    getSuppliersList () {
      // 获取供应商列表
      getSuppliers({ paging: false }).then(res => {
        this.supplierList = res.data
      })
    }
  }
}
</script>

  <style scoped>
  </style>
